<div mat-dialog-content>
  <div style="white-space: pre-wrap;">{{ log }}</div>
</div>
<div mat-dialog-actions class="mat-dialog-actions">
  <button mat-button [mat-dialog-close]="false">
    <i class="fas fa-times"></i> Close
  </button>
</div>
